//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Badge from "@Shared/components/general/badge.vue";
import { ENUM_FILOGIX_STATUS } from "@Shared/js/enum";
import { isEmpty } from "lodash";
import { getNewStatusAfterSubmission } from "@Broker/js/custom/utils";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "LenderSubmissionChangesTable",
  components: {
    Badge
  },
  props: {
    lenderSubmissions: {
      type: Array,
      default: () => []
    },
    completeStatus: {
      type: String,
      default: ""
    },
    applicationCompleted: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      table: {
        columns: ["date", "type", "lender", "status", "insurance", "mortgage", "loanAmount"]
      }
    };
  },
  computed: {
    isEmptyData() {
      return isEmpty(this.lenderSubmissions);
    },
    options() {
      return {
        filterable: false,
        showChildRowToggler: false,
        perPage: 999999,
        headings: {
          date: this.$t("global.words.date"),
          type: this.$tc("global.words.type", 1),
          lender: this.$t("global.words.lender"),
          status: this.$t("global.words.status"),
          insurance: this.$t("global.words.insurance"),
          mortgage: this.$t("global.doorr.mortgage"),
          loanAmount: this.$t("direct-to-lender.lenderSubmit.loanAmount")
        },
        texts: {
          count: ""
        },
        tabbable: false,
        skin: "table table-hover"
      };
    }
  },
  methods: {
    getNewStatus(currentStatus) {
      return getNewStatusAfterSubmission(currentStatus, this.completeStatus, this.applicationCompleted);
    },
    checkForLenderResponseMortgage(submission) {
      var _submission$lenderRes;
      return (_submission$lenderRes = submission.lenderResponse) != null && _submission$lenderRes.responseDetails ? submission.lenderResponse.responseDetails.totalMortgageAmount : submission.totalLoanAmount;
    },
    checkForLenderResponseInsurance(submission) {
      var _submission$lenderRes2;
      return (_submission$lenderRes2 = submission.lenderResponse) != null && _submission$lenderRes2.responseDetails ? submission.lenderResponse.responseDetails.mortgageInsurance : submission.miPremiumAmount;
    },
    getBadgeType(currentStatus) {
      if (this.getNewStatus(currentStatus) !== ENUM_FILOGIX_STATUS.cancelled && (currentStatus === ENUM_FILOGIX_STATUS.accepted || this.applicationCompleted)) return "primary";
      return "danger";
    }
  }
});